import React from "react";

const BranchOpen = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1733_2174)">
        <rect
          x="18"
          y="5"
          width="1"
          height="13"
          transform="rotate(90 18 5)"
          fill="#023A4A"
        />
        <circle cx="19.5" cy="5.5" r="2" stroke="#023A4A" />
        <circle cx="3.5" cy="5.5" r="2" stroke="#023A4A" />
        <path d="M5.5 5.5C10 5.5 11.5 12 11.5 21" stroke="#023A4A" />
        <rect
          width="4.74328"
          height="1.04444"
          rx="0.522222"
          transform="matrix(0.722852 -0.691003 0.722852 0.691002 10.8164 21.2773)"
          fill="#023A4A"
        />
        <rect
          width="4.74329"
          height="1.04444"
          rx="0.522222"
          transform="matrix(0.722852 0.691002 -0.722852 0.691003 8.75586 18.001)"
          fill="#023A4A"
        />
      </g>
      <defs>
        <clipPath id="clip0_1733_2174">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BranchOpen;
